export default __webpack_public_path__ + "static/media/zyro-imagemujica.4d1b39da.png";